module.exports = __webpack_public_path__ + "static/media/ens-fund-ii.ba04890e.png";